// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"22b89888","453":"c8b49535"}[chunkId] + ".chunk.js";
};